import React from 'react';
import { TextInput } from '../ui/TextInput';
import { PhoneInput } from '../ui/PhoneInput';

export interface EmergenciaValues {
  readonly nombre_contacto_emergencia: string;
  readonly numero_contacto_emergencia: string;
}

interface MiembroFieldsEmergenciaProps {
  readonly values: EmergenciaValues;
  readonly onFieldChange: (field: keyof EmergenciaValues, value: string) => void;
  readonly errors: Record<string, string>;
  readonly required?: boolean;
}

export const MiembroFieldsEmergencia: React.FC<MiembroFieldsEmergenciaProps> = ({
  values, onFieldChange, errors, required = false,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <TextInput label="Nombre completo" value={values.nombre_contacto_emergencia}
      onChange={(v) => onFieldChange('nombre_contacto_emergencia', v)}
      error={errors.nombre_contacto_emergencia} required={required} />
    <PhoneInput label="Teléfono" value={values.numero_contacto_emergencia}
      onChange={(v) => onFieldChange('numero_contacto_emergencia', v)}
      error={errors.numero_contacto_emergencia} required={required} />
  </div>
);
